import styled from 'styled-components';

const Button = styled.div`
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 51px;
    padding: 16px 32px;
    margin: 12px 6px;
    text-transform: uppercase;
    text-decoration: none;
    letter-spacing: normal;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #FFF;
    background: #001EFF;
    cursor: pointer;

    i {
        margin-left: 8px;
        font-size: 10px;
    }
`;

const Dropdown = styled.div`
    position: absolute;
    top: 60px;
    right: 0;
    min-width: 286px;
    background-color: #001EFF;
    transition: all 0.2s ease 0s;
    
    visibility: ${props => props.isVisible ? 'visible' : 'hidden'};
    opacity: ${props => props.isVisible ? '1' : '0'};

    &::before {
        content: "";
        position: absolute;
        display: block;
        border: 12px transparent double;
        border-bottom: 12px #001EFF solid;
        top: -22px;
        right: 55px;
    }
`;

const Option = styled.a`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 17px 24px;
    font-size: 16px;
    color: #fff;
    text-decoration: none;
    text-transform: none;
    letter-spacing: 1px;
    font-weight: 500;

    i {
        display: inline-block;
        margin-left: 10px;
        width: 16px;
        height: 14px;
        background-image: url("/resources/images/icons/arrow.png");
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        transition: all 0.2s ease 0s;
    }

    &:hover {
        background: rgb(0, 12, 102);
        i {
            transform: translateX(20%);
        }
    }
`;

export { Button, Dropdown, Option };